export default __webpack_public_path__ + "static/media/accessory-cutting-board.067faeb5.png";